export const FETCH_CHANNELS = 'FETCH_CHANNELS'
export const FETCH_CHANNELS_SUCCESS = 'FETCH_CHANNELS_SUCCESS'
export const FETCH_CHANNELS_ERROR = 'FETCH_CHANNELS_ERROR'
export const FETCH_CHANNELS_DONE = 'FETCH_CHANNELS_DONE'
